import {createBrowserHistory} from 'history'

const history = createBrowserHistory()

window.H = history

export default history
